import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(106px, 123px));
  width: 100%;
  gap: 10px;
`;

export const TagFlag = styled.div`
  font-size: 15px;
  font-weight: 800;
  background-color: ${(params) => (params.selected ? "#071242" : "lightGrey")};
  color: ${(params) => (params.selected ? "white" : "#071242")};
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  overflow: hidden;

  border-radius: 5px;
`;
